import { render } from "./AddCompany.vue?vue&type=template&id=007b0bbb&ts=true"
import script from "./AddCompany.vue?vue&type=script&lang=ts"
export * from "./AddCompany.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/azhukovets/.nps/caiman_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__